import {Drawer} from './Drawer';
import {shakeUnsaved} from './Form/UnsavedShake';
import {transitionByClass} from "../Library/Animation";
import {FormDirtyTracker} from "../Library/FormDirtyTracker";
import {dismissAll as dismissAllToasts} from './ToastMessage';

const defaults = {
    removeFromDomOnClose: false,
    closeOutside: true,
    onCloseHandlers: [],
};

/**
 * @param {HTMLElement} sidePanel
 * @param {{
 *     removeFromDomOnClose: boolean,
 *     closeOutside: boolean,
 *     onCloseHandlers: Array<CallableFunction>,
 * }} options
 */
export const openPanel = (sidePanel, options) => {
    options = {...defaults, ...options};

    const dirtyTracker = FormDirtyTracker(sidePanel);

    sidePanel.addEventListener('sidepanel:close', () => dirtyTracker.reset());
    sidePanel.addEventListener('form:dirty', () => sidePanel.classList.add('is-dirty'));
    sidePanel.addEventListener('form:clean', () => sidePanel.classList.remove('is-dirty'));
    sidePanel.addEventListener('htmx:afterSwap', event => {
        if (event.target.closest('[data-ignore-dirty]')) {
            return;
        }

        dirtyTracker.reset();

        if (event.target.matches('[data-unsaved]') || event.target.querySelector('[data-unsaved]')) {
            dirtyTracker.touch();
        }
    });

    const isCloseable = () => !dirtyTracker.isDirty();

    const shakeFooter = () => {
        const footer = sidePanel.querySelector('footer');

        if (!footer) {
            return;
        }

        shakeUnsaved(footer);
    };

    const handleKeydown = (event) => {
        if (event.key !== 'Escape') {
            return;
        }

        if (isCloseable()) {
            drawer.close();

            return;
        }

        shakeFooter();
    };

    const onClose = async () => {
        dirtyTracker.destroy();
        document.removeEventListener('keydown', handleKeydown);

        sidePanel.dispatchEvent(new CustomEvent('sidepanel:close', {bubbles: true}));

        if (!options.removeFromDomOnClose) {
            return;
        }

        if (options.onCloseHandlers.length) {
            options.onCloseHandlers.forEach(handler => handler());
        }

        await transitionByClass(sidePanel, 'animate');

        sidePanel.parentNode.removeChild(sidePanel);
    };

    const drawer = Drawer(sidePanel, {
        onClose: onClose,
        onCloseBlocked: shakeFooter,
        closeOutside: options.closeOutside,
        beforeClose: isCloseable,
    });

    if (document.querySelector('.mask')) {
        document.querySelector('.mask').click();
    }

    dismissAllToasts();

    sidePanel.dispatchEvent(new CustomEvent('sidepanel:beforeOpen', {bubbles: true}));

    document.addEventListener('keydown', handleKeydown);

    drawer.open();
};
